// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Bv1L","productName":"Table_productName__3mMYy"};